import { RouteConfig } from 'vue-router'
import newTermIcon from '@/assets/images/icon_new_term_2022_deactive@2x.png'
import newTermIconActive from '@/assets/images/icon_new_term_2022_active@2x.png'

const Layout = () => import('../views/Layout.vue')

const Landing = () => import('../views/winter-2023/Landing.vue')
const List = () => import('../views/winter-2023/List.vue')
const Create = () => import('../views/winter-2023/Create.vue')
const Preview = () => import('../views/winter-2023/Preview.vue')

export const landingRoute: RouteConfig = {
  path: '/winter-vacation-2023-landing',
  name: 'winter_vacation_2023_landing',
  component: Landing,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2023寒假作业',
  },
}

export const createRoute: RouteConfig = {
  path: '/winter2023-vacation-homework/create',
  name: 'winter2023_vacation_homework_create',
  component: Create,
  meta: {
    title: '2023寒假作业',
  },
}

export const listRoute: RouteConfig = {
  path: '/winter2023-vacation-homework/list',
  name: 'winter2023_vacation_homework_list',
  component: List,
  meta: {
    title: '2023寒假作业',
    // showMenu: true,
  },
}

export const previewRoute: RouteConfig = {
  path: '/winter-2023-preview',
  name: 'winter_2023_preview',
  component: Preview,
  props: (route) => ({
    ...route.query,
    ...route.params,
    canUpdate: JSON.parse(route.query.canUpdate as string),
    canDelete: JSON.parse(route.query.canDelete as string),
  }),
  meta: {
    title: '作业详情',
  },
}

export const winter2023Route: RouteConfig = {
  path: '/winter-2023',
  name: 'winter_2023',
  component: Layout,
  meta: {
    title: '寒假计划',
    icon: newTermIcon,
    iconActive: newTermIconActive,
    // showMenu: true,
  },
  children: [landingRoute, listRoute, createRoute, previewRoute],
}

export default [winter2023Route]
